import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const DescriptionIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Description",
    children: /*#__PURE__*/_jsx("path", {
      d: "M25.39 2.46c-.28-.28-.67-.46-1.1-.46s-.82.17-1.1.46l-3.7 3.7H5.58A3.637 3.637 0 0 0 2 9.78v16.6c0 2 1.63 3.62 3.63 3.63h16.59c2 0 3.62-1.63 3.63-3.63v-6.22c0-.86-.7-1.56-1.56-1.56s-1.56.7-1.56 1.56v6.22c0 .29-.23.52-.52.52H5.58c-.29 0-.52-.23-.52-.52V9.77c0-.29.23-.52.52-.52h10.81l-5.64 5.64c-.17.17-.3.37-.37.6S8.3 21.7 8.3 21.7c-.06.16-.09.34-.09.53a1.545 1.545 0 0 0 2.09 1.45h-.01l6.22-2.07c.24-.08.44-.21.61-.38L29.54 8.78c.28-.28.46-.67.46-1.1s-.17-.82-.46-1.1L25.4 2.46Z"
    })
  }));
};